export enum BackgroundJobType {
  FileUpload = "FILE_UPLOAD",
  ProjectInvitation = "PROJECT_INVITATION",
  StatusChange = "STATUS_CHANGE",
  Submit = "SUBMIT",
}
